import React, { useState, useCallback } from 'react';
import { Typography, Card } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import AgentSetup from '../components/Agent/AgentSetup';
import AgentChat from '../components/Agent/AgentChat';
import AgentSummary from '../components/Agent/AgentSummary';
import GcPagina from '../components/Layout/GcPagina';
import type {
  AgentPagePhase,
  AgentMessage,
  AgentDatosExtraidos,
} from '../types/agent';
import { fct } from '../fct/tokens/tokens';

const { Title } = Typography;

interface AgentSessionState {
  sessionId: string;
  clienteId?: number;
  messages: AgentMessage[];
  datosExtraidos?: AgentDatosExtraidos;
}

const AgentPage: React.FC = () => {
  const [phase, setPhase] = useState<AgentPagePhase>('setup');
  const [session, setSession] = useState<AgentSessionState | null>(null);

  const handleSetupComplete = useCallback(
    (clienteId?: number) => {
      setSession({
        sessionId: uuidv4(),
        clienteId,
        messages: [],
      });
      setPhase('chatting');
    },
    []
  );

  const handleChatComplete = useCallback(
    (messages: AgentMessage[], datosExtraidos: AgentDatosExtraidos) => {
      setSession((prev) =>
        prev ? { ...prev, messages, datosExtraidos } : prev
      );
      setPhase('confirming');
    },
    []
  );

  const handleConfirmed = useCallback(() => {
    setPhase('done');
  }, []);

  const handleBackToChat = useCallback(() => {
    setPhase('chatting');
  }, []);

  const handleReset = useCallback(() => {
    setSession(null);
    setPhase('setup');
  }, []);

  return (
    <GcPagina seccion="Agente" titulo="Registro de actividad" contexto="Registro de actividad del agente comercial">
      <div style={{ maxWidth: 800 }}>
        <Card>
          {phase === 'setup' && (
            <AgentSetup onComplete={handleSetupComplete} />
          )}

          {phase === 'chatting' && session && (
            <AgentChat
              sessionId={session.sessionId}
              clienteId={session.clienteId}
              onComplete={handleChatComplete}
            />
          )}

          {phase === 'confirming' && session?.datosExtraidos && (
            <AgentSummary
              clienteId={session.clienteId}
              datosExtraidos={session.datosExtraidos}
              onConfirmed={handleConfirmed}
              onBack={handleBackToChat}
            />
          )}

          {phase === 'done' && (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <Title level={5} style={{ color: fct.estado.exito.texto }}>
                Actividad registrada correctamente
              </Title>
              <a onClick={handleReset} style={{ cursor: 'pointer' }}>
                Registrar otra actividad
              </a>
            </div>
          )}
        </Card>
      </div>
    </GcPagina>
  );
};

export default AgentPage;
